import React from 'react';
import { Alert, Collapse, Descriptions, Drawer, Table, Tag, Typography } from 'antd';
import dayjs from 'dayjs';
import { actionInfo, activitySummary, actorName, changesFor, changeSummary, displayValue, fieldLabel, modelLabel, redact } from './auditPresentation';

export default function AuditDetails({ record, onClose }) {
  const changes = record ? changesFor(record) : [];
  return <Drawer title="Détail de l’activité" open={!!record} onClose={onClose} width={780}>
    {record && <div className="audit-details">
      <Tag color={record.success ? 'green' : 'red'}>{record.success ? 'Réussite' : 'Échec'}</Tag>
      <Typography.Title level={4}>{activitySummary(record)}</Typography.Title>
      <Typography.Paragraph type="secondary">{changeSummary(record)}</Typography.Paragraph>
      {!record.success && <Alert showIcon type="error" message="L’opération n’a pas abouti" description={record.errorMessage || 'Aucun message d’erreur enregistré.'} />}
      <Descriptions column={1} size="small" bordered items={[
        { key: 'date', label: 'Date et heure', children: dayjs(record.createdAt).format('DD/MM/YYYY à HH:mm:ss') },
        { key: 'person', label: 'Effectué par', children: `${actorName(record)}${record.userName && record.userEmail ? ` (${record.userEmail})` : ''}` },
        { key: 'model', label: 'Module', children: modelLabel(record.model) },
        { key: 'action', label: 'Action', children: actionInfo(record.action).label },
      ]} />
      <Typography.Title level={5}>{record.action === 'create' ? 'Données créées' : record.action === 'delete' ? 'Données supprimées' : 'Ce qui a changé'}</Typography.Title>
      {changes.length > 0 ? <Table size="small" rowKey="field" pagination={false} dataSource={changes} scroll={{ x: 550 }} columns={[
        { title: 'Champ', dataIndex: 'field', width: 170, render: field => <span title={field}>{fieldLabel(field)}</span> },
        { title: 'Avant', dataIndex: 'before', render: (value, row) => <div className="audit-value audit-value-before">{displayValue(value, row.field)}</div> },
        { title: 'Après', dataIndex: 'after', render: (value, row) => <div className="audit-value audit-value-after">{displayValue(value, row.field)}</div> },
      ]} /> : <Alert type="info" showIcon message={changeSummary(record)} />}
      <Collapse items={[{ key: 'technical', label: 'Informations techniques', children: <>
        <Descriptions column={1} size="small" items={[
          { key: 'id', label: 'Activité', children: `#${record.id}` },
          { key: 'user', label: 'Identifiant utilisateur', children: record.userId ?? 'Non enregistré' },
          { key: 'request', label: 'Requête', children: record.requestId ? <Typography.Text copyable>{record.requestId}</Typography.Text> : 'Non enregistrée' },
        ]} />
        {[['Cible', record.targetWhere], ['État avant', record.before], ['État après', record.after]].map(([label, value]) => <div key={label}>
          <Typography.Text strong>{label}</Typography.Text><pre className="audit-json">{value ? JSON.stringify(redact(value), null, 2) : 'Non enregistré'}</pre>
        </div>)}
      </> }]} />
    </div>}
  </Drawer>;
}
